import { ReactComponent as AddRoomInformationSvg } from "../../assets/images/svgs/addRoomInformation.svg";

const AddRoomInformationIcon = ({ className = "", ...props }) => {
  return (
    <AddRoomInformationSvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default AddRoomInformationIcon;
